import { avatarColors } from "components/constants/Colors";


export const getColorForUsername = (value = '') => {
  const hash = value
    .split('')
    .reduce((acc, char) => acc + char.charCodeAt(0), 0);

  return avatarColors[hash % avatarColors.length];
};


export const getDisplayName = ({ username, email }) => {
  if (username && username.trim()) {
    return username;
  }

  if (email && email.includes('@')) {
    const namePart = email.split('@')[0]; 
    return namePart.replace(/\./g, ' ');  
  }

  return '';
};
